import React from 'react';
import '../styles/style_loader.css';

/**
 * Loader avec thème fleuristerie - Animation de pétales de fleur
 * @param {string} size - 'small' (24px), 'medium' (48px), 'large' (80px), 'xlarge' (120px)
 * @param {string} variant - 'primary' (fond clair) ou 'light' (fond sombre)
 * @param {boolean} showLabel - Afficher le libellé (true par défaut). Si `label` est vide, le texte est caché.
 * @param {string} label - Texte du libellé (par défaut 'Chargement')
 * @param {boolean} showDots - Afficher les points animés "..." (true par défaut)
 * @param {boolean} showRing - Afficher l'anneau rotatif décoratif (true par défaut)
 * @param {string} className - Classes CSS additionnelles
 */
const Loader = ({ size = 'medium', variant = 'primary', showLabel = true, label = 'Chargement', showDots = true, showRing = true, className = '' }) => {
  const sizeClass = `loader-${size}`;
  const variantClass = `loader-${variant}`;
  const shouldShowLabel = showLabel && label !== '';

  return (
    <div className={`floral-loader-container ${sizeClass} ${variantClass} ${className}`} role="status" aria-live="polite" aria-busy="true" aria-label={`${label} en cours`}>
      <div className="floral-loader">
        <div className="flower-center"></div>

        {[...Array(8)].map((_, index) => ( <div key={index} className="flower-petal" style={{ '--petal-index': index }}></div> ))}

        {showRing ? <div className="flower-ring"></div> : null}
      </div>

      {/* Libellé de chargement explicite */}
      {shouldShowLabel ? (
        <p className="loader-text" aria-hidden="false">
          <span className="loader-label">{label}</span>
          {showDots ? ( <span className="dots"><span>.</span><span>.</span><span>.</span></span> ) : null}
        </p>
      ) : null}
    </div>
  );
};

export default Loader;